import { render, staticRenderFns } from "./mainRight.vue?vue&type=template&id=67d8674a&scoped=true&"
import script from "./mainRight.vue?vue&type=script&lang=js&"
export * from "./mainRight.vue?vue&type=script&lang=js&"
import style0 from "./mainRight.vue?vue&type=style&index=0&id=67d8674a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8674a",
  null
  
)

export default component.exports